import { Toro } from '../common/enumerations';

export class ApiEndpointInfo
{
    environment: Toro.Environment;
    baseUrl: string;

    constructor(environment: Toro.Environment, baseUrl: string)
    {
        this.environment = environment;
        this.baseUrl = baseUrl;
    }
}
